export function calculateRepeatDuration(duration, repeat, _repeatDelay) {
    return duration * (repeat + 1);
}
//# sourceMappingURL=calc-repeat-duration.js.map